angular.module('gym.components').directive('renderFormField', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/render_form_field.html.slim'),
    scope: {
      field: '=',
      value: '='
    },
    controller: ["$scope", "$rootScope", function($scope, $rootScope) {
      var locations;
      $scope.currency = $rootScope.gym.currency_symbol;
      $scope.units = $rootScope.gym.units;
      locations = $rootScope.gym.locations;
      $scope.getLocation = function(id) {
        return _.find(locations, function(location) {
          return location.id === id;
        });
      };
      $scope.displayValue = function() {
        return $scope.value || '-';
      };
      $scope.displayMass = function() {
        if ($scope.value) {
          return `${$scope.value} ${$scope.units.mass}`;
        } else {
          return '-';
        }
      };
      $scope.displayMeasurement = function() {
        if ($scope.value) {
          return `${$scope.value} ${$scope.units.measurement}`;
        } else {
          return '-';
        }
      };
      return $scope.checkboxValue = function(value) {
        if (value === null || value === (void 0)) {
          return '-';
        }
        if (value === 't' || value === true) {
          return 'Yes';
        } else {
          return 'No';
        }
      };
    }]
  };
});
